/**
 * Featured Post component
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

const FeaturedQuery = graphql`
  {
    markdownRemark(frontmatter: { featured: { eq: true } }) {
      id
      frontmatter {
        category
        tags
        title
        date(fromNow: true)
        cover {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
      excerpt
      timeToRead
      fields {
        slug
      }
    }
  }
`;

const FeaturedPost = () => {
  const {
    markdownRemark: { frontmatter, fields, timeToRead, excerpt },
  } = useStaticQuery(FeaturedQuery);
  return (
    <div className="row pt-4 m-0 min-vh-80 w-100 justify-content-center bg-white align-content-center">
      <div className="col-md-6 p-0">
        <Link to={fields.slug}>
          <div className="card p-0 border-0 bg-dark text-white">
            <Img fluid={frontmatter.cover.childImageSharp.fluid} className="post-card-cover" />
            <div className="card-img-overlay-0 p-0">
              <span className="subtitle col-auto p-4 bg-primary text-uppercase font-weight-bold text-white">
                <small>{frontmatter.category}</small>
              </span>
            </div>
          </div>
        </Link>
      </div>
      <div className="col-md-6 p-2 align-self-center">
        <div className="col-md-8  text-md-left text-center">
          <div className="text-left text-muted">
            Published:
            <span className="text-primary">
              &ensp;
              {frontmatter.date}
            </span>
            <span>
              &ensp;&mdash;&ensp;
              {timeToRead}
              &ensp;Min Read
            </span>
          </div>
          <Link to={fields.slug}>
            <h1 className="m-0 text-md-left font-weight-bold text-center display-4 py-2">{frontmatter.title}</h1>
          </Link>
          <p className="text-muted text-md-left text-center lead">{excerpt}</p>
          <Link to={fields.slug} className="btn btn-outline-dark  rounded-0 ">
            Read more&ensp;&rarr;
          </Link>
        </div>
      </div>
    </div>
  );
};

FeaturedPost.propTypes = {
  data: PropTypes.shape({
    path: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    cover: PropTypes.object,
    title: PropTypes.string,
    category: PropTypes.string,
    date: PropTypes.string,
    excerpt: PropTypes.string,
    timeToRead: PropTypes.number,
  }).isRequired,
};

export default React.memo(FeaturedPost);
